import { render, staticRenderFns } from "./PeersStatus.vue?vue&type=template&id=a816e7c0&scoped=true"
import script from "./PeersStatus.vue?vue&type=script&lang=js"
export * from "./PeersStatus.vue?vue&type=script&lang=js"
import style0 from "./PeersStatus.vue?vue&type=style&index=0&id=a816e7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a816e7c0",
  null
  
)

export default component.exports